import { isSameMonth, isSameYear, getMonth } from "date-fns";

export const valueFormater = (dateFormater, value) => {
	if (value === undefined) {
		return null;
	}
	const [startDate, endDate] = value;

	if (isSameMonth(startDate, endDate)) {
		return dateFormater(startDate, "MMM yyyy");
	}

	if (isSameYear(startDate, endDate)) {
		if (getMonth(startDate) === 0 && getMonth(endDate) === 11) {
			return dateFormater(startDate, "yyyy");
		}

		return `${dateFormater(startDate, "MMM")} - ${dateFormater(
			endDate,
			"MMM yyyy"
		)}`;
	}

	if (getMonth(startDate) === 0 && getMonth(endDate) === 11) {
		return `${dateFormater(startDate, "yyyy")} - ${dateFormater(
			endDate,
			"yyyy"
		)}`;
	}

	return `${dateFormater(startDate, "MMM yyyy")} - ${dateFormater(
		endDate,
		"MMM yyyy"
	)}`;
};
